import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    logout: 'Logout',
    
    // Navigation
    dashboard: 'Dashboard',
    finance: 'Cash Book',
    clientsAndSuppliers: 'Clients & Suppliers',
    hrm: 'HRM',
    inventory: 'Inventory',
    invoicing: 'Invoicing',
    
    // Finance
    generalLedger: 'Cash Book',
    clients: 'Clients',
    suppliers: 'Suppliers',
    payments: 'Payments',
    paymentsAndInvoices: 'Payments & Invoices',
    recordPayment: 'Record Payment',
    
    // HRM
    employees: 'Employees',
    payroll: 'Payroll',
    vacations: 'Vacations',
    withdrawals: 'Withdrawals',
    bonuses: 'Bonuses',
    salary: 'Salary',
    netPay: 'Net Pay',
    balanceRemaining: 'Balance Remaining',
    blurSalary: 'Blur Salary',
    blurSalaryNetPay: 'Blur Salary & Net Pay',
    closeMonth: 'Close Month',
    currentMonth: 'Current Month',
    recordBonus: 'Record Bonus',
    recordWithdrawal: 'Record Withdrawal',
    allEmployees: 'All Employees',
    selectEmployee: 'Select Employee',
    employee: 'Employee',
    category: 'Category',
    noBonusesRecorded: 'No bonuses recorded yet',
    noWithdrawalsRecorded: 'No withdrawals recorded yet',
    deductibles: 'Deductibles',
    vacation: 'Vacation',
    ot: 'OT',
    ss: 'SS',
    vacationDays: 'Vacation Days',
    socialSecurity: 'SS (Social Security)',
    noteOTBonuses: 'Note: OT and Bonuses are managed through CSV upload and Bonuses tab',
    
    // Employee Categories
    all: 'All',
    administrative: 'Administrative',
    wovenLine: 'Woven Line',
    knitsLine: 'Knits Line',
    cuttingLine: 'Cutting Line',
    finishingLine: 'Finishing Line',
    
    // Payroll Close Month
    closeCurrentMonth: 'Close Current Month',
    closeMonthWarning: 'This will create a snapshot of the current month\'s payroll and reset all employees\' OT, bonuses, deductibles, and withdrawals to 0.',
    closeMonthConfirm: 'This action cannot be undone. Are you sure you want to close the current month?',
    yesCloseMonth: 'Yes, Close Month',
    monthClosedSuccess: 'Month closed successfully! OT, bonuses, deductibles, and withdrawals have been reset.',
    viewingArchived: 'Viewing archived snapshot for',
    
    // Inventory
    inventoryItems: 'Inventory Items',
    orders: 'Orders',
    itemCode: 'Item Code',
    items: 'Items',
    
    // Invoicing
    invoices: 'Invoices',
    deliveryNotes: 'Delivery Notes',
    invoiceNumber: 'Invoice Number',
    
    // Common
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    total: 'Total',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    currency: 'EGP',
    active: 'Active',
    showPrices: 'Show Prices',
    hidePrices: 'Hide Prices',
    totalDelivered: 'Total Delivered',
    pending: 'Pending',
    in_production: 'In Production',
    fulfilled: 'Fulfilled',
    completed: 'Completed',
    cancelled: 'Cancelled',
    amount: 'Amount',
    notes: 'Notes',
    phone: 'Phone',
    address: 'Address',
    delivery: 'Delivery',
    type: 'Type',
    number: 'Number',
    description: 'Description',
    credit: 'Credit',
    debit: 'Debit',
    transactionType: 'Transaction Type',
    balance: 'Balance',
    addEmployee: 'Add Employee',
    editEmployee: 'Edit Employee',
    employeeNumber: 'Employee Number',
    employeeName: 'Employee Name',
    addClient: 'Add Client',
    addSupplier: 'Add Supplier',
    addOrder: 'Add Order',
    viewDetails: 'View Details',
    
    // Dashboard
    overviewSubtitle: 'Overview of your business operations',
    financialOverview: 'Financial Overview',
    orderStatus: 'Order Status',
    totalCredit: 'Total Credit',
    totalDebit: 'Total Debit',
    dangerZone: 'Danger Zone',
    resetAllData: 'Reset All Data',
    resetDataWarning: 'Clear all business data from the system. This will delete all employees, orders, invoices, clients, suppliers, and inventory. User accounts will be preserved.',
    resetDataTitle: 'Reset All Business Data',
    resetDataConfirmTitle: 'WARNING: This action cannot be undone!',
    resetDataConfirmText: 'This will permanently delete:',
    resetDataList1: 'All employees and payroll data',
    resetDataList2: 'All orders and invoices',
    resetDataList3: 'All clients and suppliers',
    resetDataList4: 'All inventory items',
    resetDataList5: 'All bonuses and withdrawals',
    resetDataList6: 'All payroll snapshots',
    resetDataList7: 'All general ledger entries',
    userAccountsPreserved: 'User accounts will be preserved.',
    yesDeleteAllData: 'Yes, Delete All Data',
    resetting: 'Resetting...',
    
    // Client Details
    financialSummary: 'Financial Summary',
    totalInvoiced: 'Total Invoiced',
    totalPaid: 'Total Paid',
    balance: 'Balance',
    runningBalance: 'Running Balance',
    accountStatement: 'Account Statement',
    from: 'From',
    to: 'To',
    print: 'Print',
    download: 'Download',
    noOrders: 'No orders yet',
    noInvoices: 'No invoices yet',
    noPayments: 'No payments recorded yet',
    noPayrollData: 'No payroll data available',
    noEntriesYet: 'No entries yet',
    cashBook: 'Cash Book',
    addCashBookEntry: 'Add Cash Book Entry',
    finance: 'Cash Book',
    amount: 'Amount',
    balanceAutoCalc: 'Balance will be calculated automatically',
    debitAddsCredit: 'Debit adds to balance, Credit deducts from balance',
    from: 'From',
    to: 'To',
    clear: 'Clear',
    addType: 'Add Type',
    noEmployeesInCategory: 'No employees in this category',
    uploadCSV: 'Upload CSV',
    expenseCategory: 'Expense Category',
    expenseSubcategory: 'Subcategory',
    expenseItem: 'Item',
    selectCategory: 'Select category',
    selectSubcategory: 'Select subcategory',
    selectItem: 'Select item',
    addExpenseCategory: 'Add Expense Item',
    capitalPurchase: 'Capital Purchase',
    expenseBreakdown: 'Expense Breakdown',
    operatingExpenses: 'Operating Expenses',
    capitalExpenses: 'Capital Purchases',
    etaReceived: 'Received Invoices (ETA)',
    syncFromETA: 'Sync from ETA',
    syncing: 'Syncing...',
    issuer: 'Supplier',
    invoiceType: 'Type',
    etaSyncSuccess: 'Synced successfully',
    etaStatusValid: 'Valid',
    etaStatusInvalid: 'Invalid',
    etaStatusCancelled: 'Cancelled',

    // Outsourcing
    outsourcing: 'Outsourcing',
    workers: 'Workers',
    rates: 'Rates',
    addWorker: 'Add Worker',
    editWorker: 'Edit Worker',
    workerNameRequired: 'Worker name is required',
    workerUpdated: 'Worker updated',
    workerAdded: 'Worker added',
    workerDeleted: 'Worker deleted',
    noWorkersYet: 'No workers yet',
    addRate: 'Add Rate',
    editRate: 'Edit Rate',
    rateUpdated: 'Rate updated',
    rateSaved: 'Rate saved',
    rateDeleted: 'Rate deleted',
    noRatesYet: 'No rates set yet',
    itemCodeRequired: 'Item code is required',
    costPerPiece: 'Cost per Piece',
    totalWorkEgp: 'Total Work (EGP)',
    totalPaidEgp: 'Total Paid (EGP)',
    balanceEgp: 'Balance (EGP)',
    appliesToAllWorkers: 'Applies to all workers',
    saveChanges: 'Save Changes',
    backToOutsourcing: 'Back to Outsourcing',
    totalWorkValue: 'Completed Work',
    jobs: 'Jobs',
    noJobsYet: 'No jobs assigned yet',
    newJob: 'New Job',
    newJobFor: 'New Job for',
    addPayment: 'Add Payment',
    workType: 'Work Type',
    quantity: 'Quantity',
    full: 'Full',
    partial: 'Partial',
    selectOrder: 'Select order',
    autoFilledFromOrder: 'Auto-filled from order',
    autoFilledFromRates: 'Auto-filled from rates',
    createJob: 'Create Job',
    jobCreated: 'Job created',
    jobCompleted: 'Job marked complete',
    completeJob: 'Complete Job',
    completedQuantity: 'Completed Quantity',
    assignedQuantity: 'Assigned Quantity',
    jobDeleted: 'Job deleted',
    enterValidQuantity: 'Enter a valid quantity',
    enterValidCost: 'Enter a valid cost per piece',
    paymentRecorded: 'Payment recorded',
    paymentDeleted: 'Payment deleted',
    paymentDateRequired: 'Payment date is required',
    enterValidAmount: 'Enter a valid amount',
    noPaymentsYet: 'No payments recorded yet',
    jobNumber: 'Job #',
    orderNumber: 'Order #',
    costPerPc: 'Cost/pc',
    assignedDate: 'Assigned',
    completedDate: 'Completed Date',
    assigned: 'Assigned',
    loading: 'Loading...',
    workerNotFound: 'Worker not found.',
    totalPaidOf: 'Total paid',
    balanceRemainingColon: 'Balance remaining:',
    piecesAlreadyAssigned: 'pieces already assigned',
    remaining: 'remaining',
    totalCostLabel: 'Total cost:',
    of: 'of',

    // Reports
    reports: 'Reports',
    revenueReport: 'Revenue Report',
    clientBalances: 'Client Balances',
    plSummary: 'P&L Summary',
    incomeStatement: 'Income Statement',
    ordersReport: 'Orders Report',
    deliveryPerformance: 'Delivery Performance',
    payrollSummary: 'Payroll Summary',
    outsourcingReport: 'Outsourcing Report',
    totalInvoiced: 'Total Invoiced',
    totalCollected: 'Total Collected',
    outstanding: 'Outstanding',
    revenue: 'Revenue',
    costOfSales: 'Cost of Sales',
    grossProfit: 'Gross Profit',
    operatingExpenses: 'Operating Expenses',
    netIncome: 'Net Income',
    payrollCost: 'Payroll Cost',
    outsourcingCost: 'Outsourcing Cost',
    supplierPayments: 'Supplier Payments',
    totalCosts: 'Total Costs',
    netProfit: 'Net Profit',
    procToProduction: 'Procurement → Production',
    prodToDelivery: 'Production → Delivery',
    totalCycle: 'Total Cycle',
    avgCycleTime: 'Avg Cycle Time',
    year: 'Year',
    selectMonth: 'Select Month',
    selectYear: 'Select Year',
    vatCollected: 'VAT Collected',
    baseSalary: 'Base Salary',
    totalNetPay: 'Total Net Pay',
    noDataForPeriod: 'No data for selected period',
    averages: 'Averages',
    totalPieces: 'Total Pieces',
    inProduction: 'In Production',

    // Orders
    itemPrice: 'Item Price (EGP)',
    cardNumber: 'Card Number',
    cardNum: 'Card #',
    productionLine: 'Production Line',
    orderType: 'Order Type',
    cmt: 'CMT',
    fob: 'FOB',
    materials: 'Materials',
    material: 'Material',
    unit: 'Unit',
    unitPrice: 'Unit Price',
    totalCost: 'Total Cost',
    piece: 'piece',
    materialPlaceholder: 'e.g. Denim fabric',
    noMaterialsRecorded: 'none recorded',
    materialsServicesHint: 'Quantities are for the whole order. Wash, dye, print and embroidery belong in outsourcing, not here.',
    conversionCost: 'Conversion Cost',
    materialsPerPiece: 'Materials / Piece',
    fullCostPerPiece: 'Full Cost Per Piece',
    marginPerPiece: 'Margin / Piece',
    materialsMissingWarning: 'FOB cost per piece is understated — no materials recorded for',
    client: 'Client',
    selectClient: 'Select Client',
    knits: 'Knits',
    woven: 'Woven',
    sizeColorVariants: 'Size & Color Variants',
    size: 'Size',
    color: 'Color',
    qty: 'Qty',
    optional: 'Optional',
    procurementDate: 'Procurement Date',
    productionDate: 'Production Date',
    deliveryDate: 'Delivery Date',
    fulfilled: 'Fulfilled',
    line: 'Line',
    price: 'Price',
    noPrice: 'No Price',
    searchOrders: 'Search by order #, client, or item...',
    addClientFirstWarning: 'Please add clients first before creating orders. Go to Finance → Clients to add clients.',
    noOrdersFilter: 'No orders match your filter.',
    noPrice: 'No Price',
    deliveryHistory: 'Delivery History',
    noDeliveriesYet: 'No deliveries yet',
    noteNum: 'Note #',
    itemsDelivered: 'Items Delivered',
    editOrderTitle: 'Edit Order',
    procurement: 'Procurement',
    production: 'Production',
    sizePlaceholder: 'Size (e.g. S, M, L, 32, 34)',
    colorPlaceholder: 'Color (e.g. Black, Navy)',
    descriptionPlaceholder: 'e.g. T-shirts, Hoodies',
    cleaningProducts: 'Cleaning Products',
    settings: 'Settings',
    registrationNumber: 'Registration Number',
    view: 'View',
    noInvoicesYet: 'No invoices yet',
    noInvoicesMatch: 'No invoices match your filter.',
    noClientsYet: 'No clients yet',
    noSuppliersYet: 'No suppliers yet',
    noInventoryYet: 'No inventory items yet',
    noDeliveryNotesYet: 'No delivery notes yet',
    noDeliveryNotesMatch: 'No delivery notes match your filter.',
    forReadyMadeGarments: 'For Ready Made Garments',
    subtotal: 'Subtotal',
    discount: 'Discount',
    vat: 'VAT',
    sizes: 'Sizes',
    code: 'Code',

    // Loans
    loans: 'Loans',
    newLoan: 'New Loan',
    recordLoan: 'Record Loan',
    loanAmount: 'Loan Amount',
    startMonth: 'Start Month',
    repaymentPeriod: 'Repayment Period (months)',
    monthlyInstallment: 'Monthly installment',
    period: 'Period',
    repaid: 'Repaid',
    loanRecorded: 'Loan recorded',
    noLoansFound: 'No loans found',
    loanActive: 'Active',
    loanSettled: 'Settled',
    loanFilterAll: 'All',
    selectLoanFilter: 'Filter by status',
  },
  ar: {
    // Auth
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    logout: 'تسجيل الخروج',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    finance: 'خزينـــــــــــه',
    clientsAndSuppliers: 'العملاء والموردون',
    hrm: 'اجور و مرتبات',
    inventory: 'المخزون',
    invoicing: 'الفواتير',
    
    // Finance
    generalLedger: 'خزينـــــــــــه',
    clients: 'العملاء',
    suppliers: 'الموردين',
    payments: 'المدفوعات',
    paymentsAndInvoices: 'المدفوعات والفواتير',
    recordPayment: 'تسجيل دفعة',
    
    // HRM
    employees: 'الموظفين',
    payroll: 'كشوف المرتبات',
    vacations: 'الإجازات',
    withdrawals: 'مسحوبات',
    bonuses: 'المكافآت',
    salary: 'الراتب',
    netPay: 'صافي الراتب',
    balanceRemaining: 'الرصيد المتبقي',
    blurSalary: 'إخفاء الراتب',
    blurSalaryNetPay: 'إخفاء الراتب وصافي الراتب',
    closeMonth: 'إغلاق الشهر',
    currentMonth: 'الشهر الحالي',
    recordBonus: 'تسجيل مكافأة',
    recordWithdrawal: 'تسجيل مسحوب',
    allEmployees: 'كل الموظفين',
    selectEmployee: 'اختر موظف',
    employee: 'الموظف',
    category: 'الفئة',
    noBonusesRecorded: 'لا توجد مكافآت مسجلة بعد',
    noWithdrawalsRecorded: 'لا توجد مسحوبات مسجلة بعد',
    deductibles: 'خصومات',
    vacation: 'اجازات',
    ot: 'الإضافي',
    ss: 'التأمينات',
    vacationDays: 'أيام الإجازة',
    socialSecurity: 'التأمينات الاجتماعية',
    noteOTBonuses: 'ملاحظة: يتم إدارة الإضافي والمكافآت من خلال رفع ملف CSV وتبويب المكافآت',
    
    // Employee Categories
    all: 'الكل',
    administrative: 'إداري',
    wovenLine: 'خط المنسوجات',
    knitsLine: 'خط التريكو',
    cuttingLine: 'خط القص',
    finishingLine: 'خط التشطيب',
    
    // Payroll Close Month
    closeCurrentMonth: 'إغلاق الشهر الحالي',
    closeMonthWarning: 'سيتم إنشاء نسخة احتياطية من كشف المرتبات للشهر الحالي وإعادة تعيين جميع قيم الموظفين (الإضافي، المكافآت، الخصومات، والمسحوبات) إلى صفر.',
    closeMonthConfirm: 'لا يمكن التراجع عن هذا الإجراء. هل أنت متأكد من إغلاق الشهر الحالي؟',
    yesCloseMonth: 'نعم، إغلاق الشهر',
    monthClosedSuccess: 'تم إغلاق الشهر بنجاح! تم إعادة تعيين الإضافي والمكافآت والخصومات والمسحوبات.',
    viewingArchived: 'عرض نسخة محفوظة لـ',
    
    // Inventory
    inventoryItems: 'المواد',
    orders: 'الطلبات',
    itemCode: 'كود الصنف',
    items: 'الأصناف',
    
    // Invoicing
    invoices: 'الفواتير',
    deliveryNotes: 'إشعارات التسليم',
    invoiceNumber: 'رقم الفاتورة',
    
    // Common
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    search: 'بحث',
    total: 'المجموع',
    status: 'الحالة',
    date: 'التاريخ',
    actions: 'الإجراءات',
    currency: 'جنيه',
    active: 'نشط',
    showPrices: 'إظهار الأسعار',
    hidePrices: 'إخفاء الأسعار',
    totalDelivered: 'إجمالي المسلّم',
    pending: 'قيد الانتظار',
    in_production: 'في الإنتاج',
    fulfilled: 'مكتمل',
    completed: 'مكتمل',
    cancelled: 'ملغي',
    amount: 'قيمة',
    notes: 'ملحوظات',
    phone: 'الهاتف',
    address: 'العنوان',
    delivery: 'التسليم',
    type: 'النوع',
    number: 'الرقم',
    description: 'الوصف',
    credit: 'دائن',
    debit: 'مدين',
    transactionType: 'نوع المعاملة',
    balance: 'الرصيد',
    addEmployee: 'إضافة موظف',
    editEmployee: 'تعديل موظف',
    employeeNumber: 'رقم الموظف',
    employeeName: 'اسم الموظف',
    addClient: 'إضافة عميل',
    addSupplier: 'إضافة مورد',
    addOrder: 'إضافة طلب',
    viewDetails: 'عرض التفاصيل',
    
    // Dashboard
    overviewSubtitle: 'نظرة عامة على عمليات عملك',
    financialOverview: 'النظرة المالية',
    orderStatus: 'حالة الطلبات',
    totalCredit: 'إجمالي الدائن',
    totalDebit: 'إجمالي المدين',
    dangerZone: 'منطقة الخطر',
    resetAllData: 'حذف جميع البيانات',
    resetDataWarning: 'حذف جميع بيانات الأعمال من النظام. سيتم حذف جميع الموظفين والطلبات والفواتير والعملاء والموردين والمخزون. سيتم الحفاظ على حسابات المستخدمين.',
    resetDataTitle: 'حذف جميع بيانات الأعمال',
    resetDataConfirmTitle: 'تحذير: لا يمكن التراجع عن هذا الإجراء!',
    resetDataConfirmText: 'سيتم حذف نهائيًا:',
    resetDataList1: 'جميع الموظفين وبيانات كشوف المرتبات',
    resetDataList2: 'جميع الطلبات والفواتير',
    resetDataList3: 'جميع العملاء والموردين',
    resetDataList4: 'جميع عناصر المخزون',
    resetDataList5: 'جميع المكافآت والمسحوبات',
    resetDataList6: 'جميع نسخ كشوف المرتبات المحفوظة',
    resetDataList7: 'جميع إدخالات دفتر الأستاذ العام',
    userAccountsPreserved: 'سيتم الحفاظ على حسابات المستخدمين.',
    yesDeleteAllData: 'نعم، احذف جميع البيانات',
    resetting: 'جاري الحذف...',
    
    // Client Details
    financialSummary: 'الملخص المالي',
    totalInvoiced: 'إجمالي الفواتير',
    totalPaid: 'إجمالي المدفوعات',
    balance: 'الرصيد',
    runningBalance: 'الرصيد الجاري',
    accountStatement: 'كشف حساب',
    from: 'من',
    to: 'إلى',
    print: 'طباعة',
    download: 'تنزيل',
    noOrders: 'لا توجد طلبات بعد',
    noInvoices: 'لا توجد فواتير بعد',
    noPayments: 'لا توجد مدفوعات مسجلة بعد',
    noPayrollData: 'لا توجد بيانات كشف مرتبات',
    noEntriesYet: 'لا توجد إدخالات بعد',
    cashBook: 'خزينـــــــــــه',
    addCashBookEntry: 'إضافة قيد نقدي',
    finance: 'خزينـــــــــــه',
    amount: 'المبلغ',
    balanceAutoCalc: 'سيتم احتساب الرصيد تلقائياً',
    debitAddsCredit: 'المدين يضاف للرصيد، الدائن يُخصم من الرصيد',
    from: 'من',
    to: 'إلى',
    clear: 'مسح',
    addType: 'إضافة نوع',
    noEmployeesInCategory: 'لا يوجد موظفين في هذه الفئة',
    uploadCSV: 'رفع ملف CSV',
    expenseCategory: 'فئة المصروف',
    expenseSubcategory: 'الفئة الفرعية',
    expenseItem: 'البند',
    selectCategory: 'اختر الفئة',
    selectSubcategory: 'اختر الفئة الفرعية',
    selectItem: 'اختر البند',
    addExpenseCategory: 'إضافة بند مصروف',
    capitalPurchase: 'مشتريات رأسمالية',
    expenseBreakdown: 'تفصيل المصروفات',
    operatingExpenses: 'المصروفات التشغيلية',
    capitalExpenses: 'المشتريات الرأسمالية',
    etaReceived: 'الفواتير الواردة (ETA)',
    syncFromETA: 'مزامنة من ETA',
    syncing: 'جارٍ المزامنة...',
    issuer: 'المورد',
    invoiceType: 'النوع',
    etaSyncSuccess: 'تمت المزامنة بنجاح',
    etaStatusValid: 'صالحة',
    etaStatusInvalid: 'غير صالحة',
    etaStatusCancelled: 'ملغاة',

    // Outsourcing
    outsourcing: 'عمالة انـــتاج',
    workers: 'العمال',
    rates: 'الأسعار',
    addWorker: 'إضافة عامل',
    editWorker: 'تعديل بيانات العامل',
    workerNameRequired: 'اسم العامل مطلوب',
    workerUpdated: 'تم تحديث بيانات العامل',
    workerAdded: 'تم إضافة العامل',
    workerDeleted: 'تم حذف العامل',
    noWorkersYet: 'لا يوجد عمال بعد',
    addRate: 'إضافة سعر',
    editRate: 'تعديل السعر',
    rateUpdated: 'تم تحديث السعر',
    rateSaved: 'تم حفظ السعر',
    rateDeleted: 'تم حذف السعر',
    noRatesYet: 'لم يتم تحديد أسعار بعد',
    itemCodeRequired: 'كود الصنف مطلوب',
    costPerPiece: 'تكلفة القطعة',
    totalWorkEgp: 'إجمالي العمل (ج.م)',
    totalPaidEgp: 'إجمالي المدفوع (ج.م)',
    balanceEgp: 'الرصيد (ج.م)',
    appliesToAllWorkers: 'يطبق على جميع العمال',
    saveChanges: 'حفظ التغييرات',
    backToOutsourcing: 'العودة للتعهيد',
    totalWorkValue: 'العمل المنجز',
    jobs: 'الأعمال',
    noJobsYet: 'لا توجد أعمال مسندة بعد',
    newJob: 'عمل جديد',
    newJobFor: 'عمل جديد لـ',
    addPayment: 'إضافة دفعة',
    workType: 'نوع العمل',
    quantity: 'الكمية',
    full: 'كامل',
    partial: 'جزئي',
    selectOrder: 'اختر طلباً',
    autoFilledFromOrder: 'يملأ تلقائياً من الطلب',
    autoFilledFromRates: 'يملأ تلقائياً من الأسعار',
    createJob: 'إنشاء عمل',
    jobCreated: 'تم إنشاء العمل',
    jobCompleted: 'تم تعليم العمل كمكتمل',
    completeJob: 'إكمال العمل',
    completedQuantity: 'الكمية المكتملة',
    assignedQuantity: 'الكمية المحددة',
    jobDeleted: 'تم حذف العمل',
    enterValidQuantity: 'أدخل كمية صحيحة',
    enterValidCost: 'أدخل تكلفة صحيحة للقطعة',
    paymentRecorded: 'تم تسجيل الدفعة',
    paymentDeleted: 'تم حذف الدفعة',
    paymentDateRequired: 'تاريخ الدفع مطلوب',
    enterValidAmount: 'أدخل مبلغاً صحيحاً',
    noPaymentsYet: 'لا توجد دفعات مسجلة بعد',
    jobNumber: 'رقم العمل',
    orderNumber: 'رقم الطلب',
    costPerPc: 'تكلفة/قطعة',
    assignedDate: 'تاريخ الإسناد',
    completedDate: 'تاريخ الانتهاء',
    assigned: 'مُسند',
    loading: 'جاري التحميل...',
    workerNotFound: 'العامل غير موجود.',
    totalPaidOf: 'إجمالي المدفوع',
    balanceRemainingColon: 'الرصيد المتبقي:',
    piecesAlreadyAssigned: 'قطعة مسندة بالفعل',
    remaining: 'متبقي',
    totalCostLabel: 'التكلفة الإجمالية:',
    of: 'من',

    // Reports
    reports: 'التقارير',
    revenueReport: 'تقرير الإيرادات',
    clientBalances: 'أرصدة العملاء',
    plSummary: 'ملخص الأرباح والخسائر',
    incomeStatement: 'قائمة الدخل',
    ordersReport: 'تقرير الطلبات',
    deliveryPerformance: 'أداء التسليم',
    payrollSummary: 'ملخص الرواتب',
    outsourcingReport: 'تقرير التعهيد',
    totalInvoiced: 'إجمالي الفواتير',
    totalCollected: 'إجمالي المحصل',
    outstanding: 'المتبقي',
    revenue: 'الإيرادات',
    costOfSales: 'تكلفة المبيعات',
    grossProfit: 'إجمالي الربح',
    operatingExpenses: 'مصاريف التشغيل',
    netIncome: 'صافي الدخل',
    payrollCost: 'تكلفة الرواتب',
    outsourcingCost: 'تكلفة التعهيد',
    supplierPayments: 'مدفوعات الموردين',
    totalCosts: 'إجمالي التكاليف',
    netProfit: 'صافي الربح',
    procToProduction: 'الشراء ← الإنتاج',
    prodToDelivery: 'الإنتاج ← التسليم',
    totalCycle: 'الدورة الكاملة',
    avgCycleTime: 'متوسط وقت الدورة',
    year: 'السنة',
    selectMonth: 'اختر الشهر',
    selectYear: 'اختر السنة',
    vatCollected: 'ضريبة القيمة المضافة المحصلة',
    baseSalary: 'الراتب الأساسي',
    totalNetPay: 'إجمالي صافي الراتب',
    noDataForPeriod: 'لا توجد بيانات للفترة المختارة',
    averages: 'المتوسطات',
    totalPieces: 'إجمالي القطع',
    inProduction: 'قيد الإنتاج',

    // Orders
    itemPrice: 'سعر الصنف (ج.م)',
    cardNumber: 'رقم الكرت',
    cardNum: 'رقم الكرت',
    productionLine: 'خط الإنتاج',
    orderType: 'نوع الطلب',
    cmt: 'تصنيع فقط',
    fob: 'خامة وتصنيع',
    materials: 'الخامات',
    material: 'الخامة',
    unit: 'الوحدة',
    unitPrice: 'سعر الوحدة',
    totalCost: 'إجمالي التكلفة',
    piece: 'قطعة',
    materialPlaceholder: 'مثال: قماش جينز',
    noMaterialsRecorded: 'لا توجد خامات مسجلة',
    materialsServicesHint: 'الكميات للطلب بالكامل. الغسيل والصباغة والطباعة والتطريز تُسجّل في المقاولات وليس هنا.',
    conversionCost: 'تكلفة التصنيع',
    materialsPerPiece: 'الخامات / القطعة',
    fullCostPerPiece: 'التكلفة الكاملة للقطعة',
    marginPerPiece: 'هامش الربح / القطعة',
    materialsMissingWarning: 'تكلفة القطعة (خامة وتصنيع) أقل من الحقيقة — لا توجد خامات مسجلة للطلبات',
    client: 'العميل',
    selectClient: 'اختر عميل',
    knits: 'تريكو',
    woven: 'منسوجات',
    sizeColorVariants: 'المقاسات والألوان',
    size: 'المقاس',
    color: 'اللون',
    qty: 'الكمية',
    optional: 'اختياري',
    procurementDate: 'تاريخ الشراء',
    productionDate: 'تاريخ الإنتاج',
    deliveryDate: 'تاريخ التسليم',
    fulfilled: 'منجز',
    line: 'الخط',
    price: 'السعر',
    noPrice: 'بدون سعر',
    searchOrders: 'بحث برقم الطلب أو العميل أو الصنف...',
    addClientFirstWarning: 'يرجى إضافة عملاء أولاً قبل إنشاء الطلبات. اذهب إلى المالية ← العملاء.',
    noOrdersFilter: 'لا توجد طلبات تطابق الفلتر.',
    noPrice: 'بدون سعر',
    deliveryHistory: 'سجل التسليم',
    noDeliveriesYet: 'لا توجد تسليمات بعد',
    noteNum: 'رقم الإشعار',
    itemsDelivered: 'الأصناف المُسلَّمة',
    editOrderTitle: 'تعديل الطلب',
    procurement: 'الشراء',
    production: 'الإنتاج',
    sizePlaceholder: 'المقاس (مثال: S, M, L)',
    colorPlaceholder: 'اللون (مثال: أسود، نيلي)',
    descriptionPlaceholder: 'مثال: تيشيرتات، هوديز',
    cleaningProducts: 'منتجات تنظيف',
    settings: 'الإعدادات',
    registrationNumber: 'رقم التسجيل',
    view: 'عرض',
    noInvoicesYet: 'لا توجد فواتير بعد',
    noInvoicesMatch: 'لا توجد فواتير تطابق الفلتر',
    noClientsYet: 'لا يوجد عملاء بعد',
    noSuppliersYet: 'لا يوجد موردون بعد',
    noInventoryYet: 'لا توجد عناصر مخزون بعد',
    noDeliveryNotesYet: 'لا توجد مذكرات تسليم بعد',
    noDeliveryNotesMatch: 'لا توجد مذكرات تسليم تطابق الفلتر',
    forReadyMadeGarments: 'للملابس الجاهزة',
    subtotal: 'المجموع الفرعي',
    discount: 'خصم',
    vat: 'ضريبة القيمة المضافة',
    sizes: 'المقاسات',
    code: 'الكود',

    // Loans
    loans: 'السلف',
    newLoan: 'سلفة جديدة',
    recordLoan: 'تسجيل سلفة',
    loanAmount: 'مبلغ السلفة',
    startMonth: 'شهر البداية',
    repaymentPeriod: 'فترة السداد (شهور)',
    monthlyInstallment: 'القسط الشهري',
    period: 'المدة',
    repaid: 'المسدد',
    loanRecorded: 'تم تسجيل السلفة',
    noLoansFound: 'لا توجد سلف مسجلة',
    loanActive: 'نشطة',
    loanSettled: 'مسددة',
    loanFilterAll: 'الكل',
    selectLoanFilter: 'تصفية حسب الحالة',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('language') || 'en';
    setLanguage(savedLang);
    document.documentElement.lang = savedLang;
    document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'en' ? 'ar' : 'en';
    setLanguage(newLang);
    localStorage.setItem('language', newLang);
    document.documentElement.lang = newLang;
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};